import { type FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Heading, Text } from '@chakra-ui/react';

import { TeamMemberTransitionDisabledReason } from '__generated__/GQL';
import Button from 'components/_core/Button';
import BackButton from 'components/BackButton';
import * as Layout from 'layouts/StickyStepperLayout';

import * as routes from '../../../../../../../../routes';
import locales from './locales';

type CannotEditTeamMemberProps = {
  reason?: TeamMemberTransitionDisabledReason;
};

type TranslatedDisabledReason = keyof typeof locales.reasonDescriptions;

export const CannotEditTeamMember: FC<CannotEditTeamMemberProps> = ({
  reason,
}) => {
  const history = useHistory();

  const handleBackButtonClick = () => {
    history.push(routes.members);
  };

  const description =
    reason && locales.reasonDescriptions[reason as TranslatedDisabledReason]
      ? locales.reasonDescriptions[reason as TranslatedDisabledReason]
      : locales.description;

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.HeaderButtonsContainer>
          <BackButton onClick={handleBackButtonClick} />
        </Layout.HeaderButtonsContainer>
        <Layout.ContentsContainer gap="space-32">
          <Heading size="lg">{locales.title}</Heading>
          <Text variant="secondary">{description}</Text>
          <Button onClick={handleBackButtonClick}>{locales.goBack}</Button>
        </Layout.ContentsContainer>
      </Layout.Body>
    </Layout.Root>
  );
};
